<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap>
      <v-flex md12>
        <app-table hide-create :config="config" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import config from './config_index.js'

export default {
  data () {
    return { config }
  }
}
</script>
